export var CanCancelOrderResponse;
(function (CanCancelOrderResponse) {
    CanCancelOrderResponse.OrderCancellableStatusEnum = {
        IsCancellable: 'IsCancellable',
        OrderProcessing: 'OrderProcessing',
        Unauthorized: 'Unauthorized',
        OrderNotFound: 'OrderNotFound',
        PaymentTypeNotSupported: 'PaymentTypeNotSupported',
        NetworkException: 'NetworkException'
    };
})(CanCancelOrderResponse || (CanCancelOrderResponse = {}));
